module.exports = __webpack_public_path__ + "img/productImg.f0c37697.png";